import {
  SnackbarContent,
  useSnackbarContext,
} from '@src/main/ui/providers/snackbar/SnackbarContextProvider';
import { useCallback, useEffect, useState } from 'react';

interface ApiError {
  response?: {
    status: number;
    data: {
      message?: string;
      errors?: string[];
    };
  };
}

export const useError = (): { addError: (newError: Error) => void } => {
  const [errors, setErrors] = useState<Error[]>([]);
  const { openSnackbar } = useSnackbarContext();

  const addError = useCallback(
    (newError: Error): void => {
      setErrors((prevState) => [...prevState, newError]);
    },
    [setErrors],
  );

  useEffect(() => {
    if (errors.length > 0) {
      setErrors([]);
      errors.forEach((error) => {
        errorHandler(error, openSnackbar);
      });
    }
  }, [errors, openSnackbar]);
  return { addError };
};

const errorHandler = (
  err: Error & ApiError,
  openSnackbar: (snackbarContent: SnackbarContent) => void,
): void => {
  if (!err.response?.status || err.response?.status >= 500) {
    throw err;
  }
  openSnackbar({
    message: getMessageFromError(err),
    severity: 'error',
  });
};

const getMessageFromError = (err: Error & ApiError): string => {
  if (err.response?.status === 404) {
    return "Request couldn't be performed correctly. Please, try again later.";
  }
  if (err.response?.data?.errors?.length === 1) {
    return err.response?.data?.errors[0];
  }
  if (err.response?.data?.message) {
    return err.response?.data?.message;
  }
  return 'Unexpected error';
};
